<template>
  <div class="products-filter">
    <snow-select
      v-model="form.status"
      class="mb-4"
      label="Status"
      :options="[
        { id: '', name: 'Todos' },
        { id: 'active', name: 'Ativo' },
        { id: 'draft', name: 'Pendente' },
        { id: 'inactive', name: 'Inativo' },
        { id: 'reject', name: 'Rejeitado' },
        { id: 'in_review', name: 'Em revisão' }
      ]"
    />

    <snow-select
      v-model="form.type_product"
      class="mb-7"
      label="Tipo de Produto"
      :options="[
        { id: '', name: 'Todos' },
        { id: 'online_course', name: 'Curso online' },
        { id: 'signature', name: 'Assinatura' },
        { id: 'onsite_event', name: 'Evento presencial' }
      ]"
    />

    <!-- <calendar-picker
      v-model="form.dates"
      class="mb-5"
      position-relative
      label="Período de criação do produto"
    /> -->

    <div class="d-flex flex-column flex-lg-row gap-4">
      <snow-button
        class="w-100"
        text="Cancelar"
        variant="gray"
        size="lg"
        @click="$emit('close')"
      />
      <snow-button text="Aplicar" size="lg" class="w-100" @click="submit" />
    </div>
  </div>
</template>
<script>
import { formFields } from "@/functions/helpers";
export default {
  props: {
    params: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      ...formFields(["status", "type_product", "dates"], {
        ...this.params,
        dates: [this.params.created_at_after, this.params.created_at_before]
      })
    };
  },
  methods: {
    submit() {
      const data = {
        ...this.form,
        created_at_after: this.form.dates[0],
        created_at_before: this.form.dates[1]
      };
      delete data.dates;

      this.$emit("close");
      this.$emit("submit", data);
    }
  }
};
</script>
